<section class="works-page">
  <header class="works-hero">
    <div class="hero-copy">
      <p class="eyebrow">{{ language.isEnglish ? 'Portfolio · Selected works' : 'Portfolio · Œuvres choisies' }}</p>
      <h1>
        <span class="title-line">{{ language.isEnglish ? 'Painting the living,' : 'Peindre le vivant,' }}</span>
        <em class="title-line title-script">{{ language.isEnglish ? 'letting matter speak.' : 'laisser parler la matière.' }}</em>
      </h1>
    </div>
    <div class="hero-note">
      <p class="curatorial-note">
        <span class="note-mark" aria-hidden="true"></span>
        <span class="note-lead">{{ language.isEnglish ? 'A painting of gestures,' : 'Une peinture de gestes,' }}<br>{{ language.isEnglish ? 'layers and colours.' : 'de strates et de couleurs.' }}</span>
        <span class="note-body">{{ language.isEnglish ? 'Each work opens a space between an inner landscape and the vibrations of the world.' : 'Chaque œuvre ouvre un espace entre paysage intérieur et vibration du monde.' }}</span>
      </p>
      <a [routerLink]="[language.path('contact')]">{{ language.isEnglish ? 'Enquire about an artwork' : 'Acquérir une œuvre' }} <span>&rarr;</span></a>
    </div>
  </header>
  <div class="collection-line"><span>{{ language.isEnglish ? 'Collection' : 'Collection' }}</span><span>{{ images.length }} {{ language.isEnglish ? 'artworks' : 'œuvres' }}</span><span>{{ language.isEnglish ? 'Click to enlarge' : 'Cliquez pour agrandir' }}</span></div>
  <div class="gallery-grid">
    @for (image of images; track image; let index = $index) {
      <a
        class="gallery-card"
        [href]="image.image"
        [attr.data-pswp-width]="image.width"
        [attr.data-pswp-height]="image.height"
        [attr.data-pswp-srcset]="sourceSet(image)"
        [attr.aria-label]="(language.isEnglish ? 'Open artwork ' : 'Ouvrir l’œuvre ') + (index + 1)"
      >
        <span class="art-frame">
          <img
            [src]="image.image"
            [srcset]="sourceSet(image)"
            sizes="(max-width: 560px) 100vw, (max-width: 900px) 50vw, 33vw"
            [width]="image.width"
            [height]="image.height"
            [alt]="(language.isEnglish ? 'Artwork ' : 'Œuvre ') + (index + 1) + (language.isEnglish ? ' by Cécile Binsztock' : ' de Cécile Binsztock')"
            loading="lazy"
            decoding="async"
          />
        </span>
        <span class="art-meta"><span>{{ language.isEnglish ? 'Artwork' : 'Œuvre' }} {{ (index + 1).toString().padStart(2, '0') }}</span><span>{{ language.isEnglish ? 'View' : 'Voir' }} &nearr;</span></span>
      </a>
    }
  </div>
  <p class="artwork-copyright">
    @if (language.isEnglish) {
      &copy; C&eacute;cile Binsztock. All artworks reproduced on this website are protected by copyright. Any reproduction, distribution or use without permission is prohibited.
    } @else {
      &copy; C&eacute;cile Binsztock. Toutes les œuvres reproduites sur ce site sont prot&eacute;g&eacute;es par le droit d&rsquo;auteur. Toute reproduction, diffusion ou utilisation sans autorisation est interdite.
    }
  </p>
</section>
